import React from "react";
import { useParams } from "react-router-dom";
import { useVendor, useVendorTransactions } from "../../hooks/useVendors";
import { Box, Typography, CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import BackButton from "../Shared/BackButton";

export default function Transactions() {
  const { id } = useParams();
  const { data, isLoading, error } = useVendor(id);
  const vendor = data?.vendor ?? {};
  const { data: transactionsData, isLoading: transactionsLoading, error: transactionsError } = useVendorTransactions(id);
  const transactions = transactionsData?.transactions ?? [];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box m={4}>
        <Alert severity="error">
          Error loading vendor: {error.message}
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <Box m={4}>
        <Typography variant="h2" gutterBottom sx={{ pt: 2 }}>
          Most Recent Transactions for {vendor.vendorName}
        </Typography>
        <BackButton />
      </Box>
      {transactionsLoading && (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      )}
      {transactionsError && (
        <Box m={4}>
          <Alert severity="error">
            Error loading transactions: {transactionsError.message}
          </Alert>
        </Box>
      )}
      {transactions.length > 0
        ? (
          <Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Memo</TableCell>
                  <TableCell>Joro Subcategory</TableCell>
                  <TableCell width="100">Amount</TableCell>
                  <TableCell width="100">kgCO2e</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((transaction) => (
                  <TableRow key={transaction.id}>
                    <TableCell>{transaction.transactionDate}</TableCell>
                    <TableCell>{transaction.memo}</TableCell>
                    <TableCell>{transaction.JoroSubcategory?.joroSubcategory}</TableCell>
                    <TableCell align="right" width="100">${transaction.amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                    <TableCell align="right" width="100">{transaction.kgCO2e.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )
        : !transactionsLoading && (
          <Box m={4}>
            <Alert severity="info">
            No transactions found for this vendor.
            </Alert>
          </Box>
        )}
    </>
  );
}
